/**
 * Toast 通知 composable
 * 提供简单的成功、错误、警告、信息提示功能
 */

interface ToastOptions {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  duration?: number // 显示时长（毫秒），默认 3000
}

const toasts = ref<Array<ToastOptions & { id: number }>>([])
let toastId = 0

export const useToast = () => {
  const show = (options: ToastOptions | string) => {
    const toast: ToastOptions & { id: number } = {
      id: toastId++,
      message: typeof options === 'string' ? options : options.message,
      type: typeof options === 'string' ? 'info' : (options.type || 'info'),
      duration: typeof options === 'string' ? 3000 : (options.duration || 3000)
    }

    toasts.value.push(toast)

    // 自动移除
    setTimeout(() => {
      const index = toasts.value.findIndex(t => t.id === toast.id)
      if (index > -1) {
        toasts.value.splice(index, 1)
      }
    }, toast.duration)

    return toast.id
  }

  const success = (message: string, duration?: number) => {
    return show({ message, type: 'success', duration })
  }

  const error = (message: string, duration?: number) => {
    return show({ message, type: 'error', duration })
  }

  const warning = (message: string, duration?: number) => {
    return show({ message, type: 'warning', duration })
  }

  const info = (message: string, duration?: number) => {
    return show({ message, type: 'info', duration })
  }

  const remove = (id: number) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clear = () => {
    toasts.value = []
  }

  return {
    toasts: readonly(toasts),
    show,
    success,
    error,
    warning,
    info,
    remove,
    clear
  }
}

